// Docs: https://guides.rubyonrails.org/active_storage_overview.html

import { Controller } from "stimulus"
import { DirectUpload } from "@rails/activestorage"

export default class extends Controller {
  static targets = [
    "fileInput",
    "uploadBtn",
    "progressBar",
    "fileName",
    "hiddenField",
    "uploadingBadge",
    "successBadge",
  ]

  initialize() {
    this.file = null
  }

  connect() {
    if (this.file == null) {
      this.uploadBtnTarget.disabled = true
    }
  }

  fileChanged() {
    this.file = this.fileInputTarget.files[0]
    this.uploadBtnTarget.disabled = false
    this.uploadBtnTarget.classList.remove("d-none")
    this.successBadgeTarget.classList.add("d-none")
    this.uploadingBadgeTarget.classList.add("d-none")
  }

  trigger(e) {
    if (this.file) {
      e.preventDefault()
      this.start(this.file)
      this.onUploadStarted()
      this.updateProgressBar(0)
    }
  }

  start(file) {
    const url = this.fileInputTarget.dataset.directUploadUrl
    const upload = new DirectUpload(file, url, this)

    upload.create((error, blob) => {
      if (error) {
        alert(error)
      } else {
        this.onUploadFinished(blob)
      }
    })
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress",
      event => this.directUploadDidProgress(event)
    )
  }

  directUploadDidProgress(event) {
    const percent = Math.round(event.loaded * 100 / event.total)
    this.updateProgressBar(percent)
  }

  updateProgressBar(percent) {
    const percentWithSign = `${percent}%`

    this.progressBarTarget.style.width = percentWithSign
    this.progressBarTarget.textContent = percentWithSign
    this.progressBarTarget.setAttribute("aria-valuenow", percent)
  }

  onUploadStarted() {
    this.uploadBtnTarget.classList.add("d-none")
    this.uploadingBadgeTarget.classList.remove("d-none")
    this.fileInputTarget.value = null
  }

  onUploadFinished(blob) {
    this.hiddenFieldTarget.setAttribute("value", blob.signed_id)
    this.hiddenFieldTarget.name = this.fileInputTarget.name
    this.successBadgeTarget.classList.remove("d-none")
    this.uploadingBadgeTarget.classList.add("d-none")

    // enable form submit button
    document.getElementById("sound-form-submit-btn").disabled = false
  }
}
